import { createAction } from 'redux-actions';
import * as types from './types';

export const citiesStart = createAction(types.CITIES_START);
export const citiesSuccess = createAction(types.CITIES_SUCCESS);
export const citiesError = createAction(types.CITIES_ERROR);
